import React from 'react'
import { Container, Typography } from '@material-ui/core'

export default function Banner () {
  return (
    <Container style={{ padding: '1rem 0rem 1rem   0rem' }}>
      <Typography variant='h6' align='center'>
        <b>Dashboard</b>
      </Typography>
    </Container>
  )
}
